import type { AnimationManager } from '../animation-manager';
import type { GLTF } from 'three/addons/loaders/GLTFLoader.js';

let _animationManager: AnimationManager | null = null;

export function initAnimation(objectId: string, gltf: GLTF) {
  if (!_animationManager) return;
  _animationManager.addAnimationMixerFromGLTF(objectId, gltf);
}

export function initPlayAnimationImplementation(animationManager: AnimationManager) {
  _animationManager = animationManager;
}

export async function runPlayAnimationImplementation(
  data: {
    target?: { id?: string };
    clip?: string;
    loop?: boolean;
    speed?: number;
    transitionDuration?: number;
    parallel?: boolean;
    /** @deprecated Prefer `parallel` (inverted). Kept for graphs created with the short-lived overwrite flag. */
    overwrite?: boolean;
    weight?: number;
  },
  _nodeId: string
) {
  if (!_animationManager || !data?.target?.id) return;
  const parallel = data.parallel ?? data.overwrite === false;
  await _animationManager.playAnimation(
    data.target.id,
    data.clip!,
    data.loop ?? true,
    data.speed ?? 1,
    data.transitionDuration ?? 0.2,
    parallel,
    data.weight ?? 1
  );
}
